module.exports = __webpack_public_path__ + "img/logo_blue.e510350f.png";